var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card-content",
    [
      _c(
        "w-row",
        [
          _c(
            "w-col",
            { attrs: { xs: "12" } },
            [
              _c("w-textarea", {
                attrs: { resize: "" },
                model: {
                  value: _vm.sub.rawMetadata,
                  callback: function ($$v) {
                    _vm.$set(_vm.sub, "rawMetadata", $$v)
                  },
                  expression: "sub.rawMetadata",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "w-row",
        [
          _c("w-spacer"),
          _c(
            "w-link",
            {
              on: {
                click: function ($event) {
                  return _vm.onBackClicked()
                },
              },
            },
            [_vm._v("terug")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }